import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ImageGallery from "../../components/ProductDetails/ImageGallery";
import ProductReviews from "../../components/ProductDetails/ProductReviews";
import RightSidebar from "../../components/ProductDetails/RightSidebar";
import { useGetSingleProductQuery } from "../../redux/products/productsApi";
import RelatedProducts from "./RelatedProducts";

const ProductDetails = ({ setShow }) => {
  const { id } = useParams();
  const {
    data: singleProductData,
    isLoading,
    isError,
  } = useGetSingleProductQuery(id);
  let content = null;

  return (
    <div>
      <Container>
        <Row>
          <Col className="position-sticky " md={7}>
            <ImageGallery
              isLoading={isLoading}
              isError={isError}
              singleProductData={singleProductData?.result}
            />
          </Col>
          <Col md={5}>
            <RightSidebar
              singleProductData={singleProductData?.result}
              setShow={setShow}
            />
          </Col>
        </Row>
        <RelatedProducts
          singleProductData={singleProductData}
          setShow={setShow}
        />
        <ProductReviews
          reviews={singleProductData?.result?.reviews}
          productId={id}
        />
      </Container>
    </div>
  );
};

export default ProductDetails;
